import { takeLatest, put } from "redux-saga/effects";
import { CLEAR_ERR_AND_NAVIGATE_TO_HOME } from "./actions";

function* clearErrorHandler() {
  yield put({ type: "CLEAR_ERR" });
  yield put({ type: "NAVIGATE", path: "/quiz" });
}

function* clearError() {
  yield takeLatest(CLEAR_ERR_AND_NAVIGATE_TO_HOME, clearErrorHandler);
}

export default [clearError];



// WEBPACK FOOTER //
// ./src/shells/ErrorComponent/sagas.js